import { default as ReactSelect } from 'react-select-new';
import type { Props as ReactSelectProps, StylesConfig } from 'react-select-new';
import { colors, fontSizes, spacing } from '@anyroad/theme';
import { forwardRef } from 'react';

const colorStyles: StylesConfig<any> = {
  container: (styles: any) => ({
    ...styles,
    fontSize: fontSizes.large,
    padding: '0',
    width: '100%',
  }),
  control: (styles: any) => ({
    ...styles,
    boxShadow: 'none',
    border: `1px solid ${colors.borderAction}`,
    borderRadius: 'none',
    height: '44px',
    '&:hover': {
      border: `1px solid ${colors.borderAction}`,
    },
    '&::after': {
      boxShadow: `0px 0px 10px 0px ${colors.borderAction}`,
      clipPath: 'inset(-100% 0px 0px)',
    },
  }),
  indicatorsContainer: () => ({
    paddingRight: '8px',
  }),
  menu: (styles: any) => ({
    ...styles,
    background: colors.white,
    border: `1px solid ${colors.borderAction}`,
    borderRadius: 'none',
    borderTop: 'none',
    boxShadow: 'none',
    boxSizing: 'border-box',
    margin: 0,
  }),
  menuList: (styles: any) => ({
    ...styles,
    maxHeight: '367px',
    overflowY: 'auto',
    scrollbarColor: `${colors.border} ${colors.white}`,
    scrollbarWidth: 'thin',
    padding: '0',
  }),
  option: (styles: any, { isSelected, isDisabled }) => ({
    ...styles,
    background: `${isSelected ? '#f5faff' : colors.white}`,
    boxShadow: `inset 0 1px 0 ${colors.background.light}`,
    color: isDisabled ? colors.text.placeholder : colors.text.primary,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    fontSize: fontSizes.large,
    fontWeight: '400',
    paddingLeft: spacing.medium,
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    height: '44px',
    '&:active': {
      background: isDisabled ? colors.white : colors.background.active,
      boxShadow: 'none',
    },
    '&:hover': {
      background: isDisabled ? colors.white : '#ebf5ff',
      boxShadow: 'none',
    },
  }),
  placeholder: (styles: any) => ({
    ...styles,
    color: colors.text.primary,
    left: '16px',
    top: '12px',
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: colors.text.primary,
    left: '16px',
    top: '12px',
  }),
};

export type SelectProps = ReactSelectProps;

export const Select = forwardRef<SelectProps, any>(
  ({ styles, ...rest }, ref) => (
    <ReactSelect
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ref={ref}
      styles={{
        ...colorStyles,
        ...styles,
      }}
      {...rest}
    />
  )
);

Select.displayName = 'Select';
